import { ViewState } from "react-map-gl/maplibre";
import WebMercatorViewport from "viewport-mercator-project";

import { BoundingBox } from "@nens/shared-utils";

export function boundingBoxToViewport(
  mapId: string /* Id of the container div, for its size */,
  boundingBox: BoundingBox
): ViewState | null {
  const mapContainer = document.getElementById(mapId);

  if (!mapContainer) return null;

  const mapWidth = mapContainer.clientWidth;
  const mapHeight = mapContainer.clientHeight;

  const viewportInstance = new WebMercatorViewport({
    width: mapWidth,
    height: mapHeight,
  });

  const viewport = viewportInstance.fitBounds([
    [boundingBox.westmostFloat, boundingBox.southmostFloat],
    [boundingBox.eastmostFloat, boundingBox.northmostFloat],
  ]);

  return {
    longitude: viewport.longitude,
    latitude: viewport.latitude,
    zoom: viewport.zoom,
    pitch: 0,
    bearing: 0,
    padding: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  };
}
